module.exports = __webpack_public_path__ + "static/media/resources.295fc3a1.png";